import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { create } from "zustand";

import { ENV } from "@/constants";
type Auth0 = ReturnType<typeof useAuth0>;

export interface AxiosStore {
  isAxiosInitialized: boolean;
  actions: {
    initializeAxios: (accessToken: string, logout: Auth0["logout"]) => void;
  };
}

const initialState: Omit<AxiosStore, "actions"> = {
  isAxiosInitialized: false,
};

axios.defaults.baseURL = ENV.API_BASE_URL;
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
export const useAxiosStore = create<AxiosStore>((set) => ({
  ...initialState,
  actions: {
    initializeAxios: (accessToken, logout) => {
      axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
      axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response?.status === 401) logout({ logoutParams: { returnTo: ENV.APP_BASE_URL } });
          return Promise.reject(error);
        }
      );
      set({ isAxiosInitialized: true });
    },
  },
}));
